export default "__VITE_ASSET__BXFOpHSv__"